import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-popup-close",
  "use": "icon-popup-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-popup-close\"><path d=\"M583.5 512.8L944 152.3c19.4-19.4 19.4-51.3 0-70.7-19.4-19.4-51.3-19.4-70.7 0L512.8 442.1 150.7 80C131.3 60.6 99.5 60.6 80 80c-19.4 19.4-19.4 51.3 0 70.7l362.1 362.1-362 362c-19.4 19.4-19.4 51.3 0 70.7 19.4 19.4 51.3 19.4 70.7 0l362-362L873.3 944c19.4 19.4 51.3 19.4 70.7 0 19.4-19.4 19.4-51.3 0-70.7L583.5 512.8z\" fill=\"#999999\" p-id=\"3565\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol